import { memo } from "react";
import { Row, Col } from "antd";
import ParticipantView from "./ParticipantView";

const MemoizedParticipant = memo(
  ParticipantView,
  (prevProps, nextProps) => {
    return prevProps.participantId === nextProps.participantId;
  }
);

function ParticipantGrid(
  { participantIds, isPresenting }: { participantIds: any, isPresenting: boolean }
) {
  const isMobile = window.matchMedia(
    "only screen and (max-width: 768px)"
  ).matches;

  let perRow: number;

  if (isMobile || isPresenting) {
    if (participantIds.length < 4) {
      perRow = 1;
    } else if (participantIds.length < 9) {
      perRow = 2;
    } else {
      perRow = 3;
    }
  } else if (participantIds.length < 5) {
    perRow = 2;
  } else if (participantIds.length < 7) {
    perRow = 3;
  } else if (participantIds.length < 9) {
    perRow = 4;
  } else if (participantIds.length < 10) {
    perRow = 3;
  } else if (participantIds.length < 11) {
    perRow = 4;
  } else {
    perRow = 4;
  }

  return (
    Array.from(
      { length: Math.ceil(participantIds.length / perRow) },
      (_, i) => {
        return (
          <Row
            key={`participant-${i}`}
            gutter={[16, 16]}
            style={{
              flexGrow: 1, padding: 16, height: "100%", paddingTop: "14vh"
            }}
          >
            {participantIds
              .slice(i * perRow, (i + 1) * perRow)
              .map((participantId: string) => {
                return (
                  <Col
                    key={`participant_${participantId}`}
                    span={24}
                    sm={participantIds.length === 1 ? 24 : 12}
                  >
                    <MemoizedParticipant participantId={participantId} />
                  </Col>
                );
              })}
          </Row>
        );
      }
    )
  );
}

export const MemoizedParticipantGrid = memo(
  // @ts-ignore
  ParticipantGrid,
  (prevProps, nextProps) => {
    return (
      JSON.stringify(prevProps.participantIds)
        === JSON.stringify(nextProps.participantIds)
      && prevProps.isPresenting === nextProps.isPresenting
    );
  }
);
